import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTotalCounts } from "../service/api";
import { Button } from "../components/ui/button";
import { RefreshCw } from "lucide-react";

type DashboardCounts = {
    totalBanners: number;
    totalPartners: number;
    totalBoxes: number;
    totalCities: number;
};

const Dashboard = () => {
    const navigate = useNavigate();
    const [counts, setCounts] = useState<DashboardCounts>({
        totalBanners: 0,
        totalPartners: 0,
        totalBoxes: 0,
        totalCities: 0,
    });

    useEffect(() => {
        getCounts();
    }, []);

    const getCounts = async () => {
        try {
            const res = await getTotalCounts();
            setCounts(res?.data?.data?.[0] ?? {
                totalBanners: 0,
                totalPartners: 0,
                totalBoxes: 0,
                totalCities: 0,
            });
        } catch {
            // counts stay at 0
        }
    }

    const statCards = [
        {
            label: "Total Banners",
            value: counts.totalBanners,
            onClick: () => navigate('/banner'),
            from: "from-[#7b1f36]",
            to: "to-[#5c1628]",
        },
        {
            label: "Total Partners",
            value: counts.totalPartners,
            onClick: () => navigate('/partners'),
            from: "from-[#a0253f]",
            to: "to-[#7b1f36]",
        },
        {
            label: "Total Boxes",
            value: counts.totalBoxes,
            onClick: () => navigate('/boxes'),
            from: "from-[#6b3a5e]",
            to: "to-[#4f2b46]",
        },
        {
            label: "Total Cities",
            value: counts.totalCities,
            onClick: () => navigate('/city'),
            from: "from-[#3d2b56]",
            to: "to-[#2d1f40]",
        },
    ];

    return (
        <div className="w-full max-w-6xl mx-auto pb-8 space-y-6">
            {/* Header */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div>
                    <h1 className="text-2xl font-semibold text-foreground">Dashboard</h1>
                    <p className="mt-1 text-sm text-muted-foreground">
                        Quick overview of platform health and inventory. Click a card to open the related section.
                    </p>
                </div>
                <Button variant="outline" size="sm" onClick={() => getCounts()}>
                    <RefreshCw className="h-4 w-4 mr-1" /> Refresh
                </Button>
            </div>

            {/* Stat cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {statCards.map((card) => (
                    <div
                        key={card.label}
                        onClick={card.onClick}
                        className={`bg-gradient-to-br ${card.from} ${card.to} text-white rounded-xl p-6 cursor-pointer hover:opacity-90 transition-opacity shadow-sm`}
                    >
                        <p className="text-4xl font-bold">{card.value}</p>
                        <p className="text-sm mt-1 opacity-90">{card.label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Dashboard;
